import { ReactNode } from "react";

interface TwoColumnGridProps {
    children: ReactNode;
    styling?: string; // robust styling
}

export const TwoColumnGrid: React.FC<TwoColumnGridProps> = ({children, styling}) => {
    return (
        <div className={`grid grid-cols-[max-content_minmax(0,1fr)] gap-x-6 gap-y-2 text-left ${styling}`}>
            {children}
        </div>
    )
}